let writeMode = false

export const setWriteMode = (bool: boolean) => {
  writeMode = bool
}

export const getWriteMode = () => {
  return writeMode
}
